export enum OrderStatuses {
    completed="order_status_completed",
    paid="order_status_paid",
    outstanding="order_status_payment_outstanding",
    pending="order_status_pending",
    processing="order_status_processing",
    paymentFailed="order_status_payment_failed",
    refunded="order_status_refunded",
    canceled="order_status_canceled",
    inProgress = "order_status_payment_inprogress",
    forReview = "for_review"
}